/**
 * @file attach-file.tsx
 * @description Компонент для отображения иконки прикрепленного файла.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const AttachFileIcon = ({ className, onClick }: IIconProps) => {
    return (
        <div
            className={cn('text-[#045A9A] hover:text-link-hover', className, { 'cursor-pointer': onClick })}
            onClick={onClick}
        >
            <svg
                width="0.8468vmin"
                height="1.5878vmin"
                viewBox="0 0 8 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.66667 14.1667C2.64444 14.1667 1.77778 13.8112 1.06667 13.1C0.355556 12.3889 0 11.5223 0 10.5V3.50004C0 2.76671 0.261111 2.13893 0.783333 1.61671C1.30556 1.09449 1.93333 0.833374 2.66667 0.833374C3.4 0.833374 4.02778 1.09449 4.55 1.61671C5.07222 2.13893 5.33333 2.76671 5.33333 3.50004V9.83337C5.33333 10.3 5.17222 10.6945 4.85 11.0167C4.52778 11.3389 4.13333 11.5 3.66667 11.5C3.2 11.5 2.80556 11.3389 2.48333 11.0167C2.16111 10.6945 2 10.3 2 9.83337V3.50004H3V9.83337C3 10.0223 3.06389 10.1806 3.19167 10.3084C3.31944 10.4362 3.47778 10.5 3.66667 10.5C3.85556 10.5 4.01389 10.4362 4.14167 10.3084C4.26944 10.1806 4.33333 10.0223 4.33333 9.83337V3.50004C4.33333 3.03337 4.17222 2.63893 3.85 2.31671C3.52778 1.99449 3.13333 1.83337 2.66667 1.83337C2.2 1.83337 1.80556 1.99449 1.48333 2.31671C1.16111 2.63893 1 3.03337 1 3.50004V10.5C1 11.2334 1.26111 11.8612 1.78333 12.3834C2.30556 12.9056 2.93333 13.1667 3.66667 13.1667C4.4 13.1667 5.02778 12.9056 5.55 12.3834C6.07222 11.8612 6.33333 11.2334 6.33333 10.5V3.50004H7.33333V10.5C7.33333 11.5223 6.97778 12.3889 6.26667 13.1C5.55556 13.8112 4.68889 14.1667 3.66667 14.1667Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
